import { connect } from "react-redux";
import { Link } from "react-router-dom";


var CurrentUser = require("lib/account/CurrentUser");
var DifferentiationRow = require("components/org/differentiation/DifferentiationRow");
var DropDownOptions = require("components/utility/DropDownOptions");

var Spinner = require("components/utility/Spinner");
var OrgTypes = require("lib/academic/OrgTypes");
var OrgDropdown = require("components/org/OrgDropdown");

var RosterSelectors = require("lib/selectors/RosterSelectors");

var RosterRouting = require("lib/routing/RosterRouting");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");
var StudentMetrics = require("lib/data/StudentMetrics");

require("org/differentiation/differentiation_table.scss");

@connect(
	(state, props) => ({
		students: RosterSelectors.studentsForOrgIdentifier({ state, orgIdentifier: props.orgIdentifier }),
	}),
	(dispatch, props) => ({
	})
)
class DifferentiationTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var openExpectationsModal = window.location.href.includes("showExpectations");

		this.state = { openExpectationsModal: openExpectationsModal, currentView: DifferentiationTable.GOALS_VIEW };
		this.expectationsModal = React.createRef();
	}

	onOrgSelect(orgIdentifier) {
		this.props.changeOrgIdentifier(orgIdentifier);
	}
 
	renderTableHeaders() {
		if (this.props.activeView == RosterRouting.VIEWS.GOALS) {
			var headerRows = (
				<div>
					<div className="header studentNameCell"></div>
					<div className="header studentNameCell"></div>
					<div className="header quizzesCell">Quizzes</div>
					<div className="header practiceCell">Supplemental Tasks</div>
				</div>
			)
		} else {
			var headerRows = (
				<div>
					<div className="header studentNameCell"></div>
					<div className="header studentNameCell"></div>
					<div className="header quizzesCell">
						Academic Level<br />
					</div>
					<div className="header practiceCell">
						Reading Level<br />
					</div>
				</div>
			)
		}
		return (
			<div className="studentRow headerRow">
				<div className="rowContent">
					{ headerRows }
				</div>
			</div>
		)
	}

	renderStudentRows() {
		var students = $wr.sortByName(this.props.students, "flexName");

		var studentRows = _.map(students, (student) => {
			return (
				<DifferentiationRow student={ student } prefs={ student.prefs } 
					activeView={ this.props.activeView } key={ student.id } />
			)
		});

		return (
			<div>
				{ studentRows }
			</div>
		)
	}
	renderEmptyState() {
		var rosterPath = "/roster?addNewStudentsButton=true";
		var emptyActionText = (
			<p>
				It looks like you haven't added any students yet.{" "}
				<Link to={ rosterPath }>Add students</Link>{" "}
				and their recent quiz data will appear here!
			</p>
		)
		var emptyImgPath = require("empty-state/dashboard.png");

		return (
			<div className="text-center">
				<EmptyStateContainer className="emptyDashboard" actionText={ emptyActionText }
					linkPath={ rosterPath } imagePath={ emptyImgPath } />	
			</div>
		);
	}

	renderGroupSettings() {
		// If this is undefined, this is for global instead
		return (
			<div className="groupDiff">
				<DifferentiationRow activeView={ this.props.activeView }
					orgIdentifier={ this.props.orgIdentifier } />
			</div>
		)
	}

	render() {
		var selector = (
			<OrgDropdown dropdownDisplay="link" 
				selectedIdentifier={ this.props.orgIdentifier }
				omitSelectionTypes={ [OrgTypes.SCHOOL_ORG] }
				onSelect={ this.onOrgSelect } />
		);

		return (
			<div className="differentiationTable">
				{ selector }
				{ this.renderTableHeaders() }
				{ this.renderGroupSettings() }
				{ this.renderStudentRows() }
			</div>
		)
	}
	componentDidMount() {
		if (this.state.openExpectationsModal) {
			this.openAssignmentModal();
		}
		$(window.document).trigger("onboarding-trigger-customize-assignments");
	}
};


DifferentiationTable.WrappedComponent.propTypes = StrictPropTypes({
	// Data inserted by @connect
	students: PropTypes.array.isRequired,

	// From above component
	changeOrgIdentifier: PropTypes.func.isRequired, // Called to change subject of the table,
	orgIdentifier: PropTypes.string,
	activeView: PropTypes.string
});

var ALL_CLASSES_FAKE_ID = -999;

module.exports = DifferentiationTable;



// WEBPACK FOOTER //
// ./modules/components/org/differentiation/DifferentiationTable.js